import React from 'react';
import '../App.css'; // Importing CSS

const FileUpload = ({ onFileSelect, uploadedFileName }) => {
  return (
    <div className="input_label">
      <input type="file" id="file" accept=".docx,.pdf" onChange={e => onFileSelect(e)} required/>
      <label htmlFor="file">{uploadedFileName}</label>
      <img src="/images/paper_clip.png" alt="paper_clip_icon" />
    </div>
  );
};

export default FileUpload;
